const $ = window.jQuery;

export default {
  init() {
    // JavaScript to be fired on the home page
    $('#particles-ces').particleground({
      dotColor: 'rgba(0,119, 2238, .7 )',
      lineColor: 'rgba(0,119, 2238, .5 )',
      particleRadius: 4,
      lineWidth: 1,
      direction: 'up',
      proximity: 150,
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
